import { render, staticRenderFns } from "./TvList.vue?vue&type=template&id=48c0aee8&scoped=true"
import script from "./TvList.vue?vue&type=script&lang=js"
export * from "./TvList.vue?vue&type=script&lang=js"
import style0 from "./TvList.vue?vue&type=style&index=0&id=48c0aee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c0aee8",
  null
  
)

export default component.exports